/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {Product} from '../../../core/_models'
import {formatDateTime} from '../../../../../utils/dayJs/format'

type Props = {
  product: Product
}

const CreatedInCell: FC<Props> = ({product}) => (
  <div className='d-flex flex-column'>
    {product.createdAt ? formatDateTime(product.createdAt.toString()) : 'N/A'}
    {/* <span>{franchise.createdAt ? franchise.createdAt.toString() : 'N/A'}</span> */}
  </div>
)

export {CreatedInCell}
